import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;
const upUrl = process.env.REACT_APP_UP_URL;



export const loginApi = async (data) => {
    return await axios.post(`${baseUrl}auth/login`, data);
  };

export const contactUsApi = async (data) => {
    return await axios.post(`${baseUrl}contact-us`, data);
};

export const changePassApi = async (data,token) => {
  return await axios.post(`${baseUrl}auth/change-password`, data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const forgotpassapi = async (data) => {
  return await axios.post(`${baseUrl}auth/forgot-password`, data)
}

export const resetpassapi = async (data,token) => {
  return await axios.post(`${baseUrl}auth/reset-password`, data,{
    headers: { Authorization: `Bearer ${token}` }
}); 
}



export const getAllLanguage = async (token) => {
  return await axios.get(`${upUrl}voice-languages/getAll`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const getAllVoiceType = async (token) => {
  return await axios.get(`${upUrl}voice-types/getAll`, {
    headers: { Authorization: `Bearer ${token}` }
});
};


export const getAllConnectivity = async (token) => {
  return await axios.get(`${upUrl}connectivities/getAll`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const getVoiceTalent = async (token) => {
  return await axios.get(`${upUrl}specialtiesVo/getAll`, {
    headers: { Authorization: `Bearer ${token}` }
  });
}

export const getProducer = async (token) => {
  return await axios.get(`${upUrl}specialtiesPro/getAll`, {
    headers: { Authorization: `Bearer ${token}` }
  });
}

export const getDirector = async (token) => {
  return await axios.get(`${upUrl}specialtiesDir/getAll`, {
    headers: { Authorization: `Bearer ${token}` }
  });
}

export const getAgent = async (token) => {
    return await axios.get(`${upUrl}specialtiesAgent/getAll`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    }
    
    export const getEngineer = async (token) => {
      return await axios.get(`${upUrl}specialtiesEng/getAll`, {
        headers: { Authorization: `Bearer ${token}` }
      });
    }
    
    export const getRecordingstudio = async (token) => {
      return await axios.get(`${upUrl}specialtiesStudio/getAll`, {
        headers: { Authorization: `Bearer ${token}` }
      });
    }
    
    export const getAllUserData = async (token) => {
      return await axios.get(`${baseUrl}user-management/getAll`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    };
    
    export const addUser = async (data, token) => {
      return await axios.post(`${baseUrl}user-management/create`, data, {
        headers: { Authorization: `Bearer ${token}` }
    });
    };

    export const getUserDetailsById = async (id, token) => {
  return await axios.get(`${baseUrl}user-management/findById/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getUserManagementByEdit = async (id, data, token) => {
  return await axios.put(`${baseUrl}user-management/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getUserBydelete = async (id, token) => {
  return await axios.delete(`${baseUrl}user-management/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}

export const getApprove = async (id, data, token) => {
  return await axios.put(`${baseUrl}user-management/approve/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}



// -------------------------------------------------------------------------------------------------------------------------------------------------------
// Event Management

export const AddEvent = async (data, token) => {
  return await axios.post(`${baseUrl}event-management/create`, data, {
    headers: { Authorization: `Bearer ${token}` }
});
};

export const getAllEventData = async (token) => {
  return await axios.get(`${baseUrl}event-management/getAll`, {
    headers: { Authorization: `Bearer ${token}` }
});
};

export const getAllEventRequestData = async (token) => {
  return await axios.get(`${baseUrl}event-management/getAllEventRequest`, {
    headers: { Authorization: `Bearer ${token}` }
});
};


export const getAllEventOnGoingData = async (token) => {
  return await axios.get(`${baseUrl}event-management/getAllOngoingEvent`, {
    headers: { Authorization: `Bearer ${token}` }
});
};


export const getAllPastEventData = async (token) => {
  return await axios.get(`${baseUrl}/event-management/getAllPastEvent`, {
    headers: { Authorization: `Bearer ${token}` }
});
};



export const getEventDetailsById = async (id, token) => {
  return await axios.get(`${baseUrl}event-management/findById/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getEventUpdate = async (id,data,token) => {
  return await axios.put(`${baseUrl}event-management/update/${id}`, data,  {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getEventdelete = async (id, token) => {
  return await axios.delete(`${baseUrl}event-management/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getEventApprove = async (id, token) => {
  return await axios.put(`${baseUrl}event-management/approve/${id}`,"", {
    headers: { Authorization: `Bearer ${token}` }
});
}

export const getEventReject = async (id, token) => {
  return await axios.put(`${baseUrl}event-management/reject/${id}`, "", {
    headers: { Authorization: `Bearer ${token}` }
});
}


// -------------------------------------------------------------------------------------------------------------------------------------------------------
// News Management



export const AddNewNews = async (data, token) => {
  return await axios.post(`${baseUrl}news-management/create`, data, {
    headers: { Authorization: `Bearer ${token}` }
});
};

export const getAllNewData = async (token) => {
  return await axios.get(`${baseUrl}news-management/getAll`, {
    headers: { Authorization: `Bearer ${token}` }
});
};


export const getNewsDetailsById = async (id, token) => {
  return await axios.get(`${baseUrl}news-management/findById/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getNewsUpdate = async (id, data, token) => {
  return await axios.put(`${baseUrl}news-management/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getNewsdelete = async (id, token) => {
  return await axios.delete(`${baseUrl}news-management/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


// -------------------------------------------------------------------------------------------------------------------------------------------------------
// profile Setting

// export const getUserProfileDetail = async (token) => {
//   return await axios.get(`${baseUrl}auth/user-profile-detail`, {
//     headers: { Authorization: `Bearer ${token}` }
// });
// };

export const getUserProfileDetail = async (token) => {
  return await axios.get(`${baseUrl}auth/user-profile-detail`, {
    headers: { Authorization: `Bearer ${token}` }
});
};


export const getUserProfileUpdate = async (id, data, token) => {
  return await axios.put(`${baseUrl}auth/user-profile-update`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


// -------------------------------------------------------------------------------------------------------------------------------------------------------
// Badges Module




export const AddBadge = async (data,token) => {
  return await axios.post(`${upUrl}badges/add`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}



export const getAllBadgeData = async (token) => {
  return await axios.get(`${upUrl}badges/getAll`, {
    headers: { Authorization: `Bearer ${token}` }
});
};



export const getBadgeById = async (id, token) => {
  return await axios.get(`${upUrl}badges/findById/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getBadgeUpdate = async (id, data, token) => {
  return await axios.put(`${upUrl}badges/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}

export const getBadgesDelete = async (id, token) => {
  return await axios.delete(`${upUrl}/badges/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}



// -------------------------------------------------------------------------------------------------------------------------------------------
// Brand Logo

export const AddBrandlogo = async (data,token) => {
  return await axios.post(`${baseUrl}brand/create`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}

export const getAllBrandlogoData = async (token,type) => {
  return await axios.get(`${baseUrl}brand/get?type=${type}`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 


export const getBrandlogoUpdate = async (id, data, token) => {
  return await axios.put(`${baseUrl}brand/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}

// -------------------------------------------------------------------------------------------------------------------------------------------
// Hall of Fame & Super Looper


export const AddHallofFame = async (data,token) => {
  return await axios.post(`${upUrl}hall-of-fame/add`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}

export const AddSuperLooper = async (data,token) => {
  return await axios.post(`${upUrl}super-looper/add`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}

export const DeleteHallOfFame = async (id, token) => {
  return await axios.delete(`${upUrl}hall-of-fame/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}

export const DeleteSuperLooper = async (id, token) => {
  return await axios.delete(`${upUrl}super-looper/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}

export const AddCourtesy = async (id, token) => {
  return await axios.post(
    `${baseUrl}user-management/add-courtesy/${id}`,
    {}, 
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
};

export const DeleteCourtesy = async (id, token) => {
  return await axios.put(
    `${baseUrl}user-management/update-courtesy/${id}`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
};




// -------------------------------------------------------------------------------------------------------------------------------------------
// Country & City & State


export const getAllCountry = async (token) => {
  return await axios.get(`${upUrl}countries/countries`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 

export const getAllState = async (isoCode,token) => {
  return await axios.get(`${upUrl}countries/states?countryCode=${isoCode}`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 

export const getAllCity = async (stateCode,countryCode,token) => {
  return await axios.get(`${upUrl}countries/cities?countryCode=${countryCode}&stateCode=${stateCode}`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 


// -------------------------------------------------------------------------------------------------------------------------------------------
// Specialities form


export const AddProducer = async (data,token) => {
  return await axios.post(`${upUrl}specialtiesPro/add`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}

export const getAllProducer = async (token) => {
  return await axios.get(`${upUrl}specialtiesPro/getAll`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 

export const getProducerDetailsById = async (id, token) => {
  return await axios.get(`${upUrl}specialtiesPro/findById/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getProducerByEdit = async (id, data, token) => {
  return await axios.put(`${upUrl}specialtiesPro/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const DeleteProducer = async (id, token) => {
  return await axios.delete(`${upUrl}specialtiesPro/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


// -------------------------------------------------------------------------------------------------------------------------------------------------------
export const AddDirector = async (data,token) => {
  return await axios.post(`${upUrl}specialtiesDir/add`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}

export const getAllDirector = async (token) => {
  return await axios.get(`${upUrl}specialtiesDir/getAll`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 

export const getDirectorDetailsById = async (id, token) => {
  return await axios.get(`${upUrl}specialtiesDir/findById/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getDirectorByEdit = async (id, data, token) => {
  return await axios.put(`${upUrl}specialtiesDir/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const DeleteDirector = async (id, token) => {
  return await axios.delete(`${upUrl}specialtiesDir/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}

// ------------------------------------------------------------------------------------------------------------------------------------------------------
export const AddEngineer = async (data,token) => {
  return await axios.post(`${upUrl}specialtiesEng/add`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}

export const getAllEngineer = async (token) => {
  return await axios.get(`${upUrl}specialtiesEng/getAll`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 

export const getEngineerDetailsById = async (id, token) => {
  return await axios.get(`${upUrl}specialtiesEng/findById/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getEngineerByEdit = async (id, data, token) => {
  return await axios.put(`${upUrl}specialtiesEng/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const DeleteEngineer = async (id, token) => {
  return await axios.delete(`${upUrl}specialtiesEng/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}

// ------------------------------------------------------------------------------------------------------------------------------------------------------
// Agent specialities

export const AddAgent = async (data,token) => {
  return await axios.post(`${upUrl}specialtiesAgent/add`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}

export const getAllAgent = async (token) => {
  return await axios.get(`${upUrl}specialtiesAgent/getAll`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 

export const getAgentDetailsById = async (id, token) => {
  return await axios.get(`${upUrl}specialtiesAgent/findById/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getAgentByEdit = async (id, data, token) => {
  return await axios.put(`${upUrl}specialtiesAgent/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const DeleteAgent = async (id, token) => {
  return await axios.delete(`${upUrl}specialtiesAgent/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


// -------------------------------------------------------------------------------------------------------------------------------------------------------


export const AddVoiceTalent = async (data,token) => {
  return await axios.post(`${upUrl}specialtiesVo/add`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}

export const getAllVoiceTalent = async (token) => {
  return await axios.get(`${upUrl}specialtiesVo/getAll`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 

export const getVoiceTalentDetailsById = async (id, token) => {
  return await axios.get(`${upUrl}specialtiesVo/findById/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getVoiceTalentByEdit = async (id, data, token) => {
  return await axios.put(`${upUrl}specialtiesVo/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const DeleteVoiceTalent = async (id, token) => {
  return await axios.delete(`${upUrl}specialtiesVo/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


// -------------------------------------------------------------------------------------------------------------------------------------------------------

export const AddRecordingStudio = async (data,token) => {
  return await axios.post(`${upUrl}specialtiesStudio/add`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}

export const getAllRecordingStudio = async (token) => {
  return await axios.get(`${upUrl}specialtiesStudio/getAll`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 

export const getRecordingDetailsById = async (id, token) => {
  return await axios.get(`${upUrl}specialtiesStudio/findById/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getRecordingStudioByEdit = async (id, data, token) => {
  return await axios.put(`${upUrl}specialtiesStudio/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const DeleteRecordingStudio = async (id, token) => {
  return await axios.delete(`${upUrl}specialtiesStudio/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


// -------------------------------------------------------------------------------------------------------------------------------------------------------

// Voice Type
export const AddVoiceType = async (data,token) => {
  return await axios.post(`${upUrl}voice-types/add`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}

export const getVoiceTypeByEdit = async (id, data, token) => {
  return await axios.put(`${upUrl}voice-types/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}



export const DeleteVoiceType = async (id,token) => {
  return await axios.delete(`${upUrl}voice-types/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}

// -------------------------------------------------------------------------------------------------------------------------------------------------------

// Voice language

export const AddVoicelangugae = async (data,token) => {
  return await axios.post(`${upUrl}voice-languages/add`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}

export const getVoicelanguageByEdit = async (id, data, token) => {
  return await axios.put(`${upUrl}voice-languages/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const DeleteVoicelanguage = async (id,token) => {
  return await axios.delete(`${upUrl}voice-languages/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


// -------------------------------------------------------------------------------------------------------------------------------------------------------

// Connectivity

export const AddConnectivity = async (data,token) => {
  return await axios.post(`${upUrl}connectivities/add`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}

export const getConnectivityByEdit = async (id, data, token) => {
  return await axios.put(`${upUrl}connectivities/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const DeleteConnectivity = async (id,token) => {
  return await axios.delete(`${upUrl}connectivities/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}

// -------------------------------------------------------------------------------------------------------------------------------------------------------


export const getAllRole = async (token) => {
  return await axios.get(`${baseUrl}auth/getAll`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 


export const AddRole = async (data,token) => {
  return await axios.post(`${baseUrl}auth/create-admin`, data,{
    headers: {Authorization: `Bearer ${token}`}
  });
}


export const getRoleEdit = async (id, data, token) => {
  return await axios.put(`${baseUrl}auth/update/${id}`,data, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const DeleteRole = async (id,token) => {
  return await axios.delete(`${baseUrl}auth/delete/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}

export const getRoleById = async (id, token) => {
  return await axios.get(`${baseUrl}auth/findById/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
});
}


export const getAppPurchase = async (token) => {
  return await axios.get(`${upUrl}receipt/getAll`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 

// Membership api 



export const getPlanByUser = async (userId,token) => {
  return await axios.get(`${upUrl}receipt/userPlanDetails/${userId}`, {
    headers: { Authorization : `Bearer ${token}`}
  })
} 

